// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--zmL_w";
export var wrapper = "Footer-module--wrapper--30n07";